import { jsxs as j, jsx as n, Fragment as Y } from "react/jsx-runtime";
import { c as Z } from "react/compiler-runtime";
import { TableRow as _, TableCell as B, Checkbox as ee, Box as te, Tooltip as le, IconButton as ne, TableHead as oe } from "@mui/material";
import { flexRender as ie } from "@tanstack/react-table";
import { u as se } from "../../../chunks/TableContext.js";
import re from "@mui/icons-material/FilterAlt";
import ce from "@mui/icons-material/FilterAltOff";
import { useState as q, useEffect as de } from "react";
import ae from "./ColumnFilter.js";
import { ColumnResizer as me } from "./ColumnResizer.js";
import { styles as l } from "./styles.js";
function He() {
  const e = Z(26), {
    table: m,
    getUniqueValuesForColumn: C,
    columnFilters: I,
    disableFilters: c,
    columnSizing: R,
    handleResize: w,
    handleResizeStart: S,
    handleResizeEnd: F,
    enableSelection: M,
    selectedRows: H,
    toggleAllRowsSelection: z,
    data: v,
    isDraggable: E,
    isLoading: i,
    headerSx: T
  } = se(), y = M === void 0 ? !1 : M;
  let u;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    element: null,
    columnId: ""
  }, e[0] = u) : u = e[0];
  const [f, k] = q(u), [D, O] = q(null);
  let h, p;
  e[1] !== i ? (h = () => {
    i && k({
      element: null,
      columnId: ""
    });
  }, p = [i], e[1] = i, e[2] = h, e[3] = p) : (h = e[2], p = e[3]), de(h, p);
  const W = v.length > 0 && H.size === v.length, A = H.size > 0 && H.size < v.length;
  let d;
  e[4] !== T ? (d = {
    ...l.tableHead,
    ...T
  }, e[4] = T, e[5] = d) : d = e[5];
  let a;
  e[6] !== W || e[7] !== f || e[8] !== I || e[9] !== R || e[10] !== c || e[11] !== y || e[12] !== C || e[13] !== w || e[14] !== F || e[15] !== S || e[16] !== D || e[17] !== E || e[18] !== i || e[19] !== A || e[20] !== m || e[21] !== z ? (a = m.getHeaderGroups().map((g) => {
    const P = g.headers.filter(ue);
    return /* @__PURE__ */ j(_, { sx: l.tableHeaderRow, children: [
      y && /* @__PURE__ */ n(B, { sx: {
        ...l.tableHeaderCell,
        ...l.headerSelectionCell
      }, children: /* @__PURE__ */ n(ee, { indeterminate: A, checked: W, onChange: z, sx: l.checkbox }) }),
      E && /* @__PURE__ */ n(B, { sx: {
        ...l.tableHeaderCell,
        ...l.headerDragCell
      } }),
      g.headers.map((t, U) => {
        const G = (o, X) => {
          o.stopPropagation(), k({
            element: o.currentTarget,
            columnId: X
          });
        }, s = t.column.columnDef, r = t.id, b = I.some((o) => o.id === r), $ = f.columnId === r, J = D === r, K = t.column.getIsGrouped(), N = !c && (b || $ || J), Q = P.findIndex((o) => o.id === t.id) === P.length - 1, L = R[t.id] ?? (typeof s.width == "number", s.width), V = typeof L == "number" ? `${L}px` : L || "auto";
        return t.id !== "expander" && !K && /* @__PURE__ */ j(B, { id: t.id, align: "left", sx: {
          ...l.tableHeaderCell,
          width: V,
          maxWidth: s.maxWidth || V,
          minWidth: s.minWidth || V,
          paddingLeft: "16px",
          paddingRight: Q ? "32px" : "16px"
        }, onMouseEnter: () => !c && O(r), onMouseLeave: () => !c && O(null), children: [
          t.isPlaceholder ? null : ie(t.column.columnDef.header, t.getContext()),
          !c && !s.disableFilter && !i && /* @__PURE__ */ j(Y, { children: [
            (m.getRowCount() === 0 && b || m.getRowCount() > 0) && /* @__PURE__ */ n(te, { sx: {
              ...l.filterIconContainer,
              opacity: N ? 1 : 0
            }, children: /* @__PURE__ */ n(le, { title: "Filter", children: /* @__PURE__ */ n(ne, { onClick: (o) => G(o, r), color: b ? "primary" : "default", sx: l.filterIcon, children: b ? /* @__PURE__ */ n(re, { sx: l.filterIconSvg }) : /* @__PURE__ */ n(ce, { sx: {
              ...l.filterIconSvg,
              color: "#c5c4c4"
            } }) }) }) }),
            $ && /* @__PURE__ */ n(ae, { columnId: r, anchorEl: f.element, onClose: () => k({
              element: null,
              columnId: ""
            }), options: C(r) })
          ] }),
          s.enableResizing !== !1 && U !== g.headers.length - 1 && /* @__PURE__ */ n(me, { columnId: t.id, onResize: w, onResizeStart: S, onResizeEnd: F })
        ] }, t.id);
      })
    ] }, g.id);
  }), e[6] = W, e[7] = f, e[8] = I, e[9] = R, e[10] = c, e[11] = y, e[12] = C, e[13] = w, e[14] = F, e[15] = S, e[16] = D, e[17] = E, e[18] = i, e[19] = A, e[20] = m, e[21] = z, e[22] = a) : a = e[22];
  let x;
  return e[23] !== d || e[24] !== a ? (x = /* @__PURE__ */ n(oe, { sx: d, children: a }), e[23] = d, e[24] = a, e[25] = x) : x = e[25], x;
}
function ue(e) {
  return e.id !== "expander";
}
export {
  He as TableHeader
};
